export default "__VITE_ASSET__W_n_OzXz__"